import React, { useMemo } from 'react';

import { Select } from '~/eds/src/components/Select/Select';
import { useDebouncedState } from '~/eds/src/hooks/useDebouncedState';
import { Option } from '~/eds/src/types/Option';
import { PilotId } from '~/eds/src/types/PilotId';
import { SharedSelectProps } from '~/eds/src/types/SharedSelectProps';
import { api } from '~/redux/api/createApi';
import { DropdownFieldValue } from '~/types/Field';

interface Props<M> extends SharedSelectProps<DropdownFieldValue['value'], M> {
  fieldId: PilotId;
}
export const FieldValueSelect = <M extends boolean>({
  fieldId,
  value,
  onChange,
  name,
  ...rest
}: Props<M>) => {
  const [debouncedSearch, _search, setSearch] = useDebouncedState<string>('');
  const { data, isFetching } = api.endpoints.getFieldValues.useQuery({
    fieldId: fieldId as string,
    searchSuggestions: true,
    substringQuery: debouncedSearch,
  });
  const options: Option<DropdownFieldValue['value']>[] = useMemo(() => {
    if (data) {
      return data.values.map(({ value, display_value }) => ({
        label: display_value,
        value: value,
      }));
    }
    return [];
  }, [data]);

  return (
    <Select
      {...rest}
      isLoading={isFetching}
      enableSelectAll={false}
      value={value}
      onChange={onChange}
      name={name}
      options={options}
      onSearch={setSearch}
    />
  );
};
